// extracted by mini-css-extract-plugin
module.exports = {"container":"AttractionList_container__3ylTU","placeName":"AttractionList_placeName__Dsg9m"};